import { css } from '@emotion/css';
import { StatsCountMiniBC } from 'models/mini-bc-model';
import React from 'react';

import naiIcon from 'assets/images/mini-bc/ico-1.svg';
import bauIcon from 'assets/images/mini-bc/ico-5.svg';
import gaIcon from 'assets/images/mini-bc/ico-3.svg';
import caIcon from 'assets/images/mini-bc/ico-4.svg';
import cuaIcon from 'assets/images/mini-bc/ico-2.svg';
import tomIcon from 'assets/images/mini-bc/ico-6.svg';

interface Props {
    statsData: StatsCountMiniBC;
    hisIssueList: number[][];
}
export default function StatsMiniBC(props: Props) {
    const { statsData, hisIssueList } = props;
    return (
        <div className={styles.statsTable}>
            <div className="col-item col-2">
                <div className="stats-color">
                    <img src={naiIcon} />
                    <p>{statsData.nai}</p>
                </div>
                <div className="stats-color">
                    <img src={bauIcon} />
                    <p>{statsData.bau}</p>
                </div>
                <div className="stats-color">
                    <img src={gaIcon} />
                    <p>{statsData.ga}</p>
                </div>
                <div className="stats-color">
                    <img src={caIcon} />

                    <p>{statsData.ca}</p>
                </div>
                <div className="stats-color">
                    <img src={cuaIcon} />
                    <p>{statsData.cua}</p>
                </div>
                <div className="stats-color">
                    <img src={tomIcon} />
                    <p>{statsData.tom}</p>
                </div>
            </div>
            <div className="col-item col-3">
                <div className="stats-list">
                    {hisIssueList.map((issue, index) => (
                        <div className="issue" key={index}>
                            {issue.map((dice, idx) => (
                                <React.Fragment key={idx}>
                                    {index !== hisIssueList.length - 1 ? (
                                        <img key={idx} src={require(`assets/images/mini-bc/ico-${dice}-w.svg`)} />
                                    ) : (
                                        <img key={idx} src={require(`assets/images/mini-bc/ico-${dice}.svg`)} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    ))}
                </div>
                <img className="arrow-icon" src={require(`assets/images/mini-xd/arrow-stats.png`)} />
            </div>
        </div>
    );
}

const styles = {
    statsTable: css`
        padding: 4px;
        background: #490012;
        border: 1px solid #c0a287;
        border-radius: 8px;
        display: flex;
        gap: 6px;
        margin-bottom: 10px;
        img {
            width: 15px;
        }

        .col-2 {
            flex: 0 0 42%;
            max-width: 42%;
            background: rgba(5, 23, 91, 0.7);
            border: 1px solid #3d429e;
            border-radius: 4px;
            display: flex;
            padding: 2px;
            flex-wrap: wrap;
            gap: 2px;
            .stats-color {
                flex: 0 0 calc(50% - 2px);
                max-width: calc(50% - 2px);
                display: flex;
                align-items: center;
                background: rgba(39, 39, 136, 0.6);
                padding: 0 2px;
                border-radius: 4px;
                justify-content: space-between;
                p {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                }
                .dots {
                    display: flex;
                    align-items: center;
                    gap: 2px;
                }
            }
        }
        .col-3 {
            flex: 1;
            background: rgba(5, 23, 91, 0.7);
            border-radius: 8px;
            border: 1px solid #3d429e;
            display: flex;
            align-items: center;
            .stats-list {
                flex: 1;
                display: flex;
                height: 100%;
                justify-content: space-between;
                padding: 2px;
                .issue {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    gap: 2px;
                    background: #000000;
                    padding: 2px;
                    border-right: 1px solid #646464;
                    &:last-child {
                        border-right: none;
                    }
                }
            }
            .arrow-icon {
                width: 7px;
            }
        }
    `,
};
